<div style="background-image: url(./assets/img/backsplash.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    position: fixed;
    height: 100vh;
    width: 100vw;
    background-position: center;">
</div>
